<script>
    import Popup from "./popup.svelte";
    import {popupStore} from "../stores/popupStore";
    import {onMount} from 'svelte';
    import fetchData from "../lib/fetchData";
    import Event from "./Event.svelte";
    import {dataStore} from "../stores/dataStore";

    let search = '';
    let sessions = {};
    let sessionsNotFiltered = {};
    let halls = {};
    let hallsBackup = {};
    let program = false;
    let searching = false;
    let currentDate = '';
    let currentTime = '';
    let currentHall = '';
    let selectedItem = null;
    let language = window.location.href.split('/')[3] === 'en' ? 1 : 0;
    let roles = {};
    let authors = {};
    let types = {};
    let sessionsBackup = {};
    let sessionsHall = {};
    let selectedHall = '';
    let clickedDateKey = null;
    let foundDateKey = null;
    let earliestDate = null;
    let data = {};
    let firstDateDate = null;
    let secondDateDate = null;
    let thirdDateDate = null;
    let firstDayEarliestHour = null;
    let firstDayLatestHour = null;
    let secondDayEarliestHour = null;
    let secondDayLatestHour = null;
    let thirdDayEarliestHour = null;
    let thirdDayLatestHour = null;
    let dateKey;
    let dateKeyValue;
    let foundMeeting = null;
    let hallKey;
    let activeLeftItem = 0;
    let activeLeftItems = 5;
    let resultLength = 0;
    let forwardArrowDisabled = false;
    let windowWidth = window.innerWidth;
    $: hallsLength = Object.entries(halls).length ? Object.entries(halls).length : 17;
    $: tableWidth = windowWidth > 600 ? `${Math.max(100 / hallsLength, 20)}%` : '100%';
    let backwardArrowDisabled = true;
    let confirmedNames = window['show_confirmed_names'] || false;
    let liveLinks = window['show_live_links'] || false;
    let sessionInfo = window['show_session_info'] || false;
    let wytyczneID = window['wytyczne_id'] || [];
    let videoUrl = window['video_url'] || '';
    let eventId = window['event_id'] || 120;
    let showTable = window['show_table'] ?? true;
    let exampleEvent = {};
    let days = [
        {
            0: 'Niedziela',
            1: 'Poniedziałek',
            2: 'Wtorek',
            3: 'Środa',
            4: 'Czwartek',
            5: 'Piątek',
            6: 'Sobota'
        },
        {
            0: 'Sunday',
            1: 'Monday',
            2: 'Tuesday',
            3: 'Wednesday',
            4: 'Thursday',
            5: 'Friday',
            6: 'Saturday'
        }
    ];
    let months = [
        {
            0: 'stycznia',
            1: 'lutego',
            2: 'marca',
            3: 'kwietnia',
            4: 'maja',
            5: 'czerwca',
            6: 'lipca',
            7: 'sierpnia',
            8: 'września',
            9: 'października',
            10: 'listopada',
            11: 'grudnia'
        },
        {
            0: 'January',
            1: 'February',
            2: 'March',
            3: 'April',
            4: 'May',
            5: 'June',
            6: 'July',
            7: 'August',
            8: 'September',
            9: 'October',
            10: 'November',
            11: 'December'
        }
    ];
    let searchIn = ['authors', 'lectures', 'abstracts', 'clinicalcases'];
    let authors_names = ['authors', 'authors_pro', 'authors_contra'];
    let timeSteps = [];
    let timeStepsBackup = []

    onMount(async () => {
        program = window.screen.width < 992;
        data = await fetchData(eventId);
        // zapisywanie w storze, dzięki temu fetch-ujemy tylko raz
        dataStore.set(data);
        // -----------------------------------
        halls = data.halls;
        hallsBackup = data.halls;
        roles = data.lang;
        authors = data.authors;
        types = data.types;
        sessions = data.sessions;
        sessionsBackup = data.sessions;
        sessionsHall = data.sessions;
        sessionsNotFiltered = sessions;

        earliestDate = Object.keys(sessions)[0];
        clickedDateKey = earliestDate;
        firstDateDate = earliestDate;
        secondDateDate = Object.keys(sessions)[1];
        thirdDateDate = Object.keys(sessions)[2];
        setDate(Object.keys(sessions)[0]);
        const allKeys = new Set();
        if (windowWidth < 600) {
            activeLeftItems = 1;
        }

        Object.keys(sessions).forEach(outerKey => {
            const innerObject = sessions[outerKey];
            Object.keys(innerObject).forEach(innerKey => {
                allKeys.add(innerKey);
            });
        });

        const hoursArray = Array.from(allKeys);

        const firstDayHoursArray = Object.keys(Object.entries(sessions)[0][1]);
        const secondDayHoursArray = Object.keys(Object.entries(sessions)[1][1]);
        //const thirdDayHoursArray = Object.keys(Object.entries(sessions)[2][1]);

        let earliestTimeFirstDay = '';
        let latestTimeFirstDay = '';
        let earliestTimeSecondDay = '';
        let latestTimeSecondDay = '';
        let earliestTimeThirdDay = '';
        let latestTimeThirdDay = '';

        const firstDayHoursArrayNew = [];
        const secondDayHoursArrayNew = [];
        const thirdDayHoursArrayNew = [];

        firstDayHoursArray.forEach(item => {
            const parts = item.split('T');
            for (let i = 0; i < parts.length; i += 2) {
                if (i + 1 < parts.length) {
                    firstDayHoursArrayNew.push(`${parts[i]}:${parts[i + 1]}`);
                }
            }
        });

        secondDayHoursArray.forEach(item => {
            const parts = item.split('T');
            for (let i = 0; i < parts.length; i += 2) {
                if (i + 1 < parts.length) {
                    secondDayHoursArrayNew.push(`${parts[i]}:${parts[i + 1]}`);
                }
            }
        });

        // thirdDayHoursArray.forEach(item => {
        //     const parts = item.split('T');
        //     for (let i = 0; i < parts.length; i += 2) {
        //         if (i + 1 < parts.length) {
        //             thirdDayHoursArrayNew.push(`${parts[i]}:${parts[i + 1]}`);
        //         }
        //     }
        // });

        const findEarliestAndLatestTimes = (times) => {
            function timeToMinutes(time) {
                const [hours, minutes] = time.split(':').map(Number);
                return hours * 60 + minutes;
            }

            let earliestTime = times[0];
            let latestTime = times[0];

            for (let i = 1; i < times.length; i++) {
                if (timeToMinutes(times[i]) < timeToMinutes(earliestTime)) {
                    earliestTime = times[i];
                }
                if (timeToMinutes(times[i]) > timeToMinutes(latestTime)) {
                    latestTime = times[i];
                }
            }

            return {
                earliest: earliestTime,
                latest: latestTime
            };
        }

        const firstDayResult = findEarliestAndLatestTimes(firstDayHoursArrayNew);
        firstDayEarliestHour = roundDownToNearestHalfHour(firstDayResult.earliest);
        firstDayLatestHour = roundDownToNearestHalfHour(firstDayResult.latest);

        const secondDayResult = findEarliestAndLatestTimes(secondDayHoursArrayNew);
        secondDayEarliestHour = roundDownToNearestHalfHour(secondDayResult.earliest);
        secondDayLatestHour = roundDownToNearestHalfHour(secondDayResult.latest);

        // const thirdDayResult = findEarliestAndLatestTimes(thirdDayHoursArrayNew);
        // thirdDayEarliestHour = roundDownToNearestHalfHour(thirdDayResult.earliest);
        // thirdDayLatestHour = roundDownToNearestHalfHour(thirdDayResult.latest);

        timeSteps = generateTimeArray(firstDayEarliestHour, firstDayLatestHour);
        timeStepsBackup = generateTimeArray(firstDayEarliestHour, firstDayLatestHour);
        handleChangeDate(earliestDate);

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('id')) {
            const id = urlParams.get('id');
            findMeetingId(data, id)
            dateKey = foundMeeting ? foundMeeting.date : '';
            dateKeyValue = foundDateKey;
            hallKey = foundMeeting ? foundMeeting.hall : '';
            popupStore.set(true);
        }
    });

    $: if (data !== null) {
        dataStore.set(data);
    }


    function roundDownToNearestHalfHour(time) {
        const [hours, minutes] = time.split(':').map(Number);
        const roundedMinutes = minutes < 30 ? 0 : 30;
        return `${String(hours).padStart(2, '0')}:${String(roundedMinutes).padStart(2, '0')}`;
    }

    function findMeetingId(data, targetId) {
        if (data.sessions) {
            for (const date in data.sessions) {
                for (const time in data.sessions[date]) {
                    for (const hall of Object.entries(data.sessions[date][time])) {
                        if (hall[1][0].id === targetId.toString()) {
                            foundDateKey = time;
                            foundMeeting = hall[1][0];
                            return hall.id;
                        }
                    }
                }
            }
        }
        return null;
    }

    function roundUpToNearestHalfHour(time) {
        let [hours, minutes] = time.split(':').map(Number);
        if (minutes > 0 && minutes <= 30) {
            minutes = 30;
        } else if (minutes > 30) {
            minutes = 0;
            hours = (hours + 1) % 24;
        }
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    }

    function setDate(id) {
        currentDate = id;
        setTime(Object.keys(sessions[currentDate])[0]);
    }

    function setTime(id) {
        currentTime = id;
        setHall(Object.keys(sessions[currentDate][currentTime])[0]);
    }

    function generateTimeArray(startTime, endTime) {
        function timeToMinutes(time) {
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
        }

        function minutesToTime(minutes) {
            const hours = String(Math.floor(minutes / 60)).padStart(2, '0');
            const mins = String(minutes % 60).padStart(2, '0');
            return `${hours}:${mins}`;
        }

        const startMinutes = timeToMinutes(startTime);
        const endMinutes = timeToMinutes(endTime);
        const halfHourStep = 30;
        const timeArray = [];

        for (let minutes = startMinutes; minutes <= endMinutes; minutes += halfHourStep) {
            timeArray.push(minutesToTime(minutes));
        }

        return timeArray;
    }

    function setHall(id) {
        currentHall = id;
    }

    function makeVideoUrl(session_id, lecture_id) {
        return `${videoUrl}?session=${session_id}&lecture=${lecture_id}`;
    }

    function changeHall(direction, isReturn) {
        if (program) {
            let obj = Object.keys(sessions[currentDate][currentTime]);
            if (direction === 0) {
                if (isReturn && obj.indexOf(currentHall) > 0) {
                    return true;
                }
                if (obj.indexOf(currentHall) - 1 >= 0) {
                    currentHall = obj[obj.indexOf(currentHall) - 1];
                }
            } else if (direction === 1) {
                if (isReturn && obj.indexOf(currentHall) + 1 < obj.length) {
                    return true;
                }
                if (obj.indexOf(currentHall) + 1 < obj.length) {
                    currentHall = obj[obj.indexOf(currentHall) + 1];
                }
            }
        } else {
            if (direction === 0) {
                if (activeLeftItem - 1 >= 0) {
                    if (isReturn) {
                        return true;
                    } else {
                        activeLeftItem -= 1;
                        modifySession();
                    }
                }
            } else if (direction === 1) {
                if (activeLeftItem + 1 + activeLeftItems <= Object.keys(halls).length) {
                    if (isReturn) {
                        return true;
                    } else {
                        activeLeftItem += 1;
                        modifySession();
                    }
                }
            }
        }
    }

    function modifySession() {
        searchPersons();
        let keys = Object.keys(halls);
        for (let date in sessions) {
            for (let time in sessions[date]) {
                for (let hall in sessions[date][time]) {
                    if (!(keys.indexOf(hall) >= activeLeftItem && keys.indexOf(hall) < activeLeftItem + activeLeftItems) && hall !== 'all') {
                        delete sessions[date][time][hall];
                    }
                }
            }
        }
    }

    const findEarliestSession = () => {
    }

    function formatDate(string, option) {
        // 1 - get day 1-31
        // 2 - get weekday mon-sun
        // 3 - get month jan-dec
        let date = new Date(string);
        let answer;
        switch (option) {
            case 1:
                answer = date.getDate();
                break;
            case 2:
                answer = days[language][date.getDay()];
                break;
            case 3:
                answer = months[language][date.getMonth()];
                break;
        }
        return answer;
    }

    function selectItem(data) {
        selectedItem = data;
    }

    function checkTime(date, time) {
        const index = Object.keys(sessions[date]);
        const time_splitted = time.split('T');
        const time_start = time[0] + 'T' + time[1];
        const time_end = time[2] + 'T' + time[3];
    }

    function checkID(id) {
        return wytyczneID.indexOf(id) > -1;
    }

    function searchPersons() {
        sessions = JSON.parse(JSON.stringify(sessionsBackup));
        resultLength = 0;
        let exist;
        if (search.length >= 3) {
            searching = true;
            for (let date in sessionsBackup) {
                for (let time in sessionsBackup[date]) {
                    for (let hall in sessionsBackup[date][time]) {
                        if (hall !== 'all') {
                            for (let session in sessionsBackup[date][time][hall]) {
                                exist = false;
                                if (sessionsBackup[date][time][hall][session].title[language].toLowerCase().includes(search.toLowerCase())) {
                                    exist = true;
                                }
                                if (sessionsBackup[date][time][hall][session].subtitle[language].toLowerCase().includes(search.toLowerCase())) {
                                    exist = true;
                                }
                                if (sessionsBackup[date][time][hall][session].info.toLowerCase().includes(search.toLowerCase())) {
                                    exist = true;
                                }
                                if (!exist) {
                                    for (let name of searchIn) {
                                        for (let property in sessionsBackup[date][time][hall][session][name]) {
                                            if (name === 'authors') {
                                                for (let index of sessionsBackup[date][time][hall][session][name][property]) {
                                                    if (authors && authors[index].lastname.toLowerCase().includes(search.toLowerCase())) {
                                                        exist = true;
                                                    }
                                                }
                                            } else {
                                                if (sessionsBackup[date][time][hall][session][name][property].title[language].toLowerCase().includes(search.toLowerCase())) {
                                                    exist = true;
                                                }
                                                if (!exist) {
                                                    for (let author_name of authors_names) {
                                                        if (!exist) {
                                                            if (sessionsBackup[date][time][hall][session][name][property].hasOwnProperty(author_name)) {
                                                                for (let index of sessionsBackup[date][time][hall][session][name][property][author_name]) {
                                                                    if (authors && authors[index].lastname.toLowerCase().includes(search.toLowerCase())) {
                                                                        exist = true;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                if (!exist) {
                                    delete sessions[date][time][hall][session];
                                } else {
                                    resultLength++;

                                }
                            }
                        }
                        sessions[date][time][hall] = sessions[date][time][hall].filter(Boolean);
                        if (Object.keys(sessions[date][time][hall]).length === 0) {
                            delete sessions[date][time][hall];
                        }
                    }
                    if (Object.keys(sessions[date][time]).length === 0) {
                        delete sessions[date][time];
                    }
                }
                if (Object.keys(sessions[date]).length === 0) {
                    delete sessions[date];
                }
                filterHallsAndTimeArray();
            }
        } else {
            searching = false;
            sessions = JSON.parse(JSON.stringify(sessionsBackup));
            halls = JSON.parse(JSON.stringify(hallsBackup));
            timeSteps = JSON.parse(JSON.stringify(timeStepsBackup));
        }

    }

    function subtractOneHourAndRoundUp(time) {
        const [hours, minutes, seconds] = time.split(':').map(Number);
        let date = new Date();
        date.setHours(hours - 1);
        date.setMinutes(minutes);
        date.setSeconds(seconds);

        if (date.getMinutes() > 0 && date.getMinutes() <= 30) {
            date.setMinutes(30);
        } else if (date.getMinutes() > 30 && date.getMinutes() <= 59) {
            date.setMinutes(0);
            date.setHours(date.getHours() + 1);
        }

        const roundedHours = String(date.getHours()).padStart(2, '0');
        const roundedMinutes = String(date.getMinutes()).padStart(2, '0');

        return `${roundedHours}:${roundedMinutes}`;
    }

    function addOneHourAndRoundUp(time) {
        const [hours, minutes, seconds] = time.split(':').map(Number);
        let date = new Date();
        date.setHours(hours + 1);
        date.setMinutes(minutes);
        date.setSeconds(seconds);

        if (date.getMinutes() > 0 && date.getMinutes() <= 30) {
            date.setMinutes(30);
        } else if (date.getMinutes() > 30 && date.getMinutes() <= 59) {
            date.setMinutes(0);
            date.setHours(date.getHours() + 1);
        }

        const roundedHours = String(date.getHours()).padStart(2, '0');
        const roundedMinutes = String(date.getMinutes()).padStart(2, '0');

        return `${roundedHours}:${roundedMinutes}`;
    }

    function generateTimeSteps(startTime, endTime) {
        const times = [];
        let current = new Date(`1970-01-01T${startTime}:00`);
        const end = new Date(`1970-01-01T${endTime}:00`);

        while (current <= end) {
            const hours = String(current.getHours()).padStart(2, '0');
            const minutes = String(current.getMinutes()).padStart(2, '0');
            times.push(`${hours}:${minutes}`);
            current.setMinutes(current.getMinutes() + 30);
        }

        return times;
    }

    function getKeysAtLevel(obj, targetLevel, currentLevel = 1, keys = new Set()) {
        if (currentLevel === targetLevel) {
            for (let key in obj) {
                keys.add(key);
            }
        } else {
            for (let key in obj) {
                if (typeof obj[key] === 'object' && obj[key] !== null) {
                    getKeysAtLevel(obj[key], targetLevel, currentLevel + 1, keys);
                }
            }
        }
        return Array.from(keys);
    }

    function findMatchingKeys(obj, keys) {
        let results = [];

        function search(obj) {
            for (const key in obj) {
                if (keys.includes(key)) {
                    results.push(obj[key][0]);
                } else if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
                    search(obj[key]);
                }
            }
        }

        search(obj);
        return results;
    }

    function filterHallsAndTimeArray() {
        halls = {};
        let timeStepsFilterBackup = timeSteps;
        for (let date in sessions) {
            for (let time in sessions[date]) {
                for (let hall in sessions[date][time]) {
                    halls[hall] = hallsBackup[hall];

                }
            }

        }
        const keysArray = getKeysAtLevel(sessions, 3);
        const objectsArray = findMatchingKeys(sessions, keysArray);

        function findEarliestAndLatestTimes(objects) {
            let earliestTimeStart = '23:59:59';
            let latestTimeEnd = '00:00:00';

            objects.forEach(obj => {
                if (obj.time_start < earliestTimeStart) {
                    earliestTimeStart = obj.time_start;
                }
                if (obj.time_end > latestTimeEnd) {
                    latestTimeEnd = obj.time_end;
                }
            });

            return {
                earliestTimeStart,
                latestTimeEnd
            };
        }

        const {earliestTimeStart, latestTimeEnd} = findEarliestAndLatestTimes(objectsArray);

        const adjustedEarliestTimeStart = subtractOneHourAndRoundUp(earliestTimeStart);
        const adjustedLatestTimeEnd = addOneHourAndRoundUp(latestTimeEnd);
        timeSteps = generateTimeSteps(adjustedEarliestTimeStart, adjustedLatestTimeEnd);
    }

    function searchHall(hall_id) {
        sessionsHall = JSON.parse(JSON.stringify(sessionsBackup));
        resultLength = 0;
        selectedHall = hall_id;
        for (let date in sessionsBackup) {
            for (let time in sessionsBackup[date]) {
                for (let hall in sessionsBackup[date][time]) {
                    if (hall !== 'all' && hall !== selectedHall) {
                        delete sessionsHall[date][time][hall];
                    }
                }
                if (Object.keys(sessionsHall[date][time]).length === 0) {
                    delete sessionsHall[date][time];
                }
            }
            if (Object.keys(sessionsHall[date]).length === 0) {
                delete sessionsHall[date];
            }
        }
        setTimeout(() => {
            window.print();
        }, 1000);
    }

    const openPopup = (e, eventId) => {
        e.preventDefault();
        popupStore.set(true);
        // const newURL = window.location.href+= `?id=${eventId}`;
        // window.history.pushState({ path: newURL }, '', newURL);
        const url = new URL(window.location.href);
        url.searchParams.set('id', eventId);
        window.history.pushState(null, '', url.toString());
    }

    $: isPopupOpen = false;

    popupStore.subscribe(value => {
        isPopupOpen = value;
    });

    function halfHourEarlier(timeStr) {
        const [hours, minutes] = timeStr.split(':').map(Number);

        const date = new Date();
        date.setHours(hours, minutes, 0, 0);

        date.setMinutes(date.getMinutes() - 30);

        const newHours = String(date.getHours()).padStart(2, '0');
        const newMinutes = String(date.getMinutes()).padStart(2, '0');

        return `${newHours}:${newMinutes}`;
    }

    function halfHourLater(timeStr) {
        const [hours, minutes] = timeStr.split(':').map(Number);

        const date = new Date();
        date.setHours(hours, minutes, 0, 0);

        date.setMinutes(date.getMinutes() + 30);
        const newHours = String(date.getHours()).padStart(2, '0');
        const newMinutes = String(date.getMinutes()).padStart(2, '0');

        return `${newHours}:${newMinutes}`;
    }

    const handleChangeDate = (dateKey, dateValue) => {
        clickedDateKey = dateKey;

        if (dateKey === firstDateDate) {
            timeSteps = generateTimeArray(halfHourEarlier(firstDayEarliestHour), halfHourLater(firstDayLatestHour));
        }
        if (dateKey === secondDateDate) {
            timeSteps = generateTimeArray(halfHourEarlier(secondDayEarliestHour), halfHourLater(secondDayLatestHour));
        }
        if (dateKey === thirdDateDate) {
            timeSteps = generateTimeArray(halfHourEarlier(thirdDayEarliestHour), halfHourLater(thirdDayLatestHour));
        }
    };


    const hallsGoBack = () => {
        if (halls) {
            if (windowWidth > 600) {
                activeLeftItem -= 5;
                activeLeftItems -= 5;
            } else {
                activeLeftItem -= 1;
                activeLeftItems -= 1;
            }
            backwardArrowDisabled = false;
            if (activeLeftItem <= 0) {
                if (windowWidth > 600) {
                    activeLeftItem = 0;
                    activeLeftItems = 5;
                } else {
                    activeLeftItem = 0;
                    activeLeftItems = 1;
                }
                backwardArrowDisabled = true;
                forwardArrowDisabled = false;
            }
            forwardArrowDisabled = false;
        }
    }

    const hallsGoForward = () => {
        if (halls) {
            const hallsLength = Object.keys(halls).length
            if (windowWidth > 600) {
                if (activeLeftItems + 5 < hallsLength) {
                    activeLeftItem += 5;
                    activeLeftItems += 5;
                } else {
                    activeLeftItem = hallsLength - 5
                    activeLeftItems = hallsLength
                }
            } else {
                if (activeLeftItems < hallsLength) {
                    activeLeftItem += 1;
                    activeLeftItems += 1;
                }
            }

            backwardArrowDisabled = false;
            forwardArrowDisabled = activeLeftItems >= hallsLength;
        }
    }

    function timeToMinutes(time) {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
    }

    function isExactMatch(timeStart, step, interval = 30) {
        const startMinutes = timeToMinutes(timeStart);
        const stepMinutes = timeToMinutes(step);
        const halfInterval = interval / 2;

        return startMinutes >= (stepMinutes - halfInterval) && startMinutes < (stepMinutes + halfInterval);
    }


    function handleEventClick(_clickedDateKey, _dateKeyValue, _hallKey, e, eventId) {
        dateKey = _clickedDateKey;
        dateKeyValue = _dateKeyValue;
        hallKey = _hallKey;

        // set new data before opening
        openPopup(e, eventId);
    }

    const idIsFound = () => {
        return true;
    }

    function updateWidth() {
        windowWidth = window.innerWidth;
        tableWidth = windowWidth > 600 ? `${Math.max(100 / hallsLength, 20)}%` : '100%';
        activeLeftItems = windowWidth > 600 ? activeLeftItem + 5 : activeLeftItem + 1;
    }

    // Update width on window resize
    window.addEventListener('resize', updateWidth);
</script>

{#if isPopupOpen && idIsFound()}
    <div class="background_color"></div>
    <Popup {dateKey} {dateKeyValue} {hallKey} {showTable}/>
{/if}

<!--<svelte:options customElement="program-new" />-->
<div class={`${isPopupOpen? "darkenBackground":""}`}>
    <div class={`flex flex-col items-center max-w-11/12`}>

        <!-- Input -->
        <div class={`flex justify-center min-w-80 w-full ${isPopupOpen ? "backdrop" : ""}`}>
            <div class={`placeholder ${isPopupOpen? "backdrop" : ""}`}></div>
            <div class={`w-1/2 search-item ${isPopupOpen? "backdrop" : ""}`}>
                <div class="w-full flex items-center p-4 gap-0">
                    <input type="text"
                           class="w-11/12 p-2 border rounded-tl rounded-bl transition hover:bg-slate-50 active:bg-slate-100 focus:bg-slate-100"
                           bind:value={search}
                           on:input={searchPersons}
                           placeholder={language === 0 ? 'Wpisz co najmniej 3 znaki aby szukać' : 'Type at least 3 characters to search'}
                    />
                    <div class="w-1/12">
                        <button class={`
                            bg-slate-700 p-2 rounded-tr rounded-br border border-slate-700 transition text-white active:scale-95`}
                                disabled={!search && search.length > 0}
                                on:click={() => {search = ''; searchPersons()}}>
                            {language === 0 ? 'Wyczyść' : 'Clear'}
                        </button>
                    </div>
                </div>
            </div>
            <div class={`placeholder ${isPopupOpen? "backdrop" : ""}`}></div>

        </div>

        {#if true}
            <div class="w-full style-nowy" style="z-index: 1500;">
                {#if sessions && halls}
                    <div class="flex">
                        <div class="w-full">
                            <div class="flex flex-col">
                                <div class="flex justify-evenly days-buttons"
                                     style="position: sticky; top: 0; height: 3rem; z-index: 100">
                                    {#each Object.entries(sessionsNotFiltered) as [dateKey, dateValue]}
                                        <button class="date-button" class:selected={clickedDateKey === dateKey}
                                                style="min-width: 30%"
                                                on:click={() => handleChangeDate(dateKey, dateValue)}>{formatDate(dateKey, 1)} {formatDate(dateKey, 3)}</button>
                                    {/each}
                                </div>
                                <table class="table-auto w-full border-collapse border border-gray-200 program-table">
                                    {#if !backwardArrowDisabled}
                                        <th class="border border-gray-200 p-2 table-header">
                                            <button style="transform: rotate(180deg); margin-top:0.2rem; position: sticky; top:3.5rem; left:70px; z-index:101;background: #b3b3b3; border-radius: 10px; padding: 0.2rem; height: 35px; width: 35px"
                                                    on:click={() => hallsGoBack()}><img
                                                    src="resources/nowy_program_glowny/icons8-arrow-50.png" alt=""/>
                                            </button>
                                        </th>
                                    {:else}
                                        <th class="border border-gray-200 p-2 table-header" style="height: 55px;">
                                        </th>
                                    {/if}
                                    {#each Object.entries(halls).slice(activeLeftItem, activeLeftItems) as [hallKey, hallValue], index (hallKey)}
                                        <th class="border border-gray-200 p-2 table-header"
                                            style="text-align: center; vertical-align: middle">
                                            {hallValue.name[0]}
                                            {#if !forwardArrowDisabled && index === Object.entries(halls).slice(activeLeftItem, activeLeftItems).length - 1}
                                                <button style="position: absolute; right:10px; top:9px; z-index:101;background: #b3b3b3; border-radius: 10px; padding: 0.2rem; height: 35px; width: 35px"
                                                        on:click={() => hallsGoForward()}><img
                                                        src="resources/nowy_program_glowny/icons8-arrow-50.png" alt=""/>
                                                </button>
                                            {/if}
                                        </th>
                                    {/each}


                                    {#each timeSteps as step}
                                        <tr class="content"

                                        >
                                            <td class="border border-gray-200 p-2 time-step">{step}</td>
                                            {#each Object.entries(halls).slice(activeLeftItem, activeLeftItems) as [hallKey, hallValue]}
                                                <td class="border border-gray-200 p-2 relative"
                                                    style="width: {tableWidth}; max-width: {tableWidth};"
                                                    id="{hallKey} - {step}">
                                                    {#each Object.entries(sessions) as [dateKey, dateValue]}
                                                        {#if clickedDateKey === dateKey}
                                                            {#each Object.entries(dateValue) as [key, value]}
                                                                {#if value[hallKey] && value[hallKey][0].hall === hallKey && isExactMatch(value[hallKey][0].time_start, step + ':00')}
                                                                    <div on:click={(e)=>handleEventClick(clickedDateKey,key,hallKey, e, value[hallKey][0].id)}
                                                                         class="cursor-pointer"
                                                                         style="width: {tableWidth}; max-width: min(400px,{tableWidth}">
                                                                        <Event startTime={value[hallKey][0].time_start}
                                                                               endTime={value[hallKey][0].time_end}
                                                                               title={value[hallKey][0].title[0]}
                                                                               englishTitle={value[hallKey][0].title[1]}
                                                                               typeId={value[hallKey][0].type}
                                                                               types={types}
                                                                               id={value[hallKey][0].id}
                                                                               wytyczne_id={wytyczneID}/>
                                                                    </div>
                                                                {/if}
                                                            {/each}
                                                        {/if}
                                                    {/each}
                                                </td>
                                            {/each}
                                        </tr>
                                    {/each}
                                </table>
                            </div>
                        </div>
                    </div>
                {/if}

            </div>
        {/if}
    </div>
</div>

<style>
    @import 'tailwindcss/tailwind.css';

    /*
    ! tailwindcss v3.4.7 | MIT License | https://tailwindcss.com
    */

    /*
    1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
    2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
    */

    *,
    ::before,
    ::after {
        box-sizing: border-box;
        /* 1 */
        border-width: 0;
        /* 2 */
        border-style: solid;
        /* 2 */
        border-color: #e5e7eb;
        /* 2 */
    }

    ::before,
    ::after {
        --tw-content: '';
    }

    /*
    1. Use a consistent sensible line-height in all browsers.
    2. Prevent adjustments of font size after orientation changes in iOS.
    3. Use a more readable tab size.
    4. Use the user's configured `sans` font-family by default.
    5. Use the user's configured `sans` font-feature-settings by default.
    6. Use the user's configured `sans` font-variation-settings by default.
    7. Disable tap highlights on iOS
    */

    html,
    :host {
        line-height: 1.5;
        /* 1 */
        -webkit-text-size-adjust: 100%;
        /* 2 */
        -moz-tab-size: 4;
        /* 3 */
        -o-tab-size: 4;
        tab-size: 4;
        /* 3 */
        font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        /* 4 */
        font-feature-settings: normal;
        /* 5 */
        font-variation-settings: normal;
        /* 6 */
        -webkit-tap-highlight-color: transparent;
        /* 7 */
    }

    /*
    1. Remove the margin in all browsers.
    2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.
    */

    body {
        margin: 0;
        /* 1 */
        line-height: inherit;
        /* 2 */
    }

    /*
    1. Add the correct height in Firefox.
    2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
    3. Ensure horizontal rules are visible by default.
    */

    hr {
        height: 0;
        /* 1 */
        color: inherit;
        /* 2 */
        border-top-width: 1px;
        /* 3 */
    }

    /*
    Add the correct text decoration in Chrome, Edge, and Safari.
    */

    abbr:where([title]) {
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
    }

    /*
    Remove the default font size and weight for headings.
    */

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-size: inherit;
        font-weight: inherit;
    }

    /*
    Reset links to optimize for opt-in styling instead of opt-out.
    */

    a {
        color: inherit;
        text-decoration: inherit;
    }

    /*
    Add the correct font weight in Edge and Safari.
    */

    b,
    strong {
        font-weight: bolder;
    }

    /*
    1. Use the user's configured `mono` font-family by default.
    2. Use the user's configured `mono` font-feature-settings by default.
    3. Use the user's configured `mono` font-variation-settings by default.
    4. Correct the odd `em` font sizing in all browsers.
    */

    code,
    kbd,
    samp,
    pre {
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
        /* 1 */
        font-feature-settings: normal;
        /* 2 */
        font-variation-settings: normal;
        /* 3 */
        font-size: 1em;
        /* 4 */
    }

    /*
    Add the correct font size in all browsers.
    */

    small {
        font-size: 80%;
    }

    /*
    Prevent `sub` and `sup` elements from affecting the line height in all browsers.
    */

    sub,
    sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
    }

    sub {
        bottom: -0.25em;
    }

    sup {
        top: -0.5em;
    }

    /*
    1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
    2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
    3. Remove gaps between table borders by default.
    */

    table {
        text-indent: 0;
        /* 1 */
        border-color: inherit;
        /* 2 */
        border-collapse: collapse;
        /* 3 */
    }

    /*
    1. Change the font styles in all browsers.
    2. Remove the margin in Firefox and Safari.
    3. Remove default padding in all browsers.
    */

    button,
    input,
    optgroup,
    select,
    textarea {
        font-family: inherit;
        /* 1 */
        font-feature-settings: inherit;
        /* 1 */
        font-variation-settings: inherit;
        /* 1 */
        font-size: 100%;
        /* 1 */
        font-weight: inherit;
        /* 1 */
        line-height: inherit;
        /* 1 */
        letter-spacing: inherit;
        /* 1 */
        color: inherit;
        /* 1 */
        margin: 0;
        /* 2 */
        padding: 0;
        /* 3 */
    }

    /*
    Remove the inheritance of text transform in Edge and Firefox.
    */

    button,
    select {
        text-transform: none;
    }

    /*
    1. Correct the inability to style clickable types in iOS and Safari.
    2. Remove default button styles.
    */

    button,
    input:where([type='button']),
    input:where([type='reset']),
    input:where([type='submit']) {
        -webkit-appearance: button;
        /* 1 */
        background-color: transparent;
        /* 2 */
        background-image: none;
        /* 2 */
    }

    /*
    Use the modern Firefox focus style for all focusable elements.
    */

    :-moz-focusring {
        outline: auto;
    }

    /*
    Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
    */

    :-moz-ui-invalid {
        box-shadow: none;
    }

    /*
    Add the correct vertical alignment in Chrome and Firefox.
    */

    progress {
        vertical-align: baseline;
    }

    /*
    Correct the cursor style of increment and decrement buttons in Safari.
    */

    ::-webkit-inner-spin-button,
    ::-webkit-outer-spin-button {
        height: auto;
    }

    /*
    1. Correct the odd appearance in Chrome and Safari.
    2. Correct the outline style in Safari.
    */

    [type='search'] {
        -webkit-appearance: textfield;
        /* 1 */
        outline-offset: -2px;
        /* 2 */
    }

    /*
    Remove the inner padding in Chrome and Safari on macOS.
    */

    ::-webkit-search-decoration {
        -webkit-appearance: none;
    }

    /*
    1. Correct the inability to style clickable types in iOS and Safari.
    2. Change font properties to `inherit` in Safari.
    */

    ::-webkit-file-upload-button {
        -webkit-appearance: button;
        /* 1 */
        font: inherit;
        /* 2 */
    }

    /*
    Add the correct display in Chrome and Safari.
    */

    summary {
        display: list-item;
    }

    /*
    Removes the default spacing and border for appropriate elements.
    */

    blockquote,
    dl,
    dd,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    hr,
    figure,
    p,
    pre {
        margin: 0;
    }

    fieldset {
        margin: 0;
        padding: 0;
    }

    legend {
        padding: 0;
    }

    ol,
    ul,
    menu {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    /*
    Reset default styling for dialogs.
    */

    dialog {
        padding: 0;
    }

    /*
    Prevent resizing textareas horizontally by default.
    */

    textarea {
        resize: vertical;
    }

    /*
    1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
    2. Set the default placeholder color to the user's configured gray 400 color.
    */

    input::-moz-placeholder, textarea::-moz-placeholder {
        opacity: 1;
        /* 1 */
        color: #9ca3af;
        /* 2 */
    }

    input::placeholder,
    textarea::placeholder {
        opacity: 1;
        /* 1 */
        color: #9ca3af;
        /* 2 */
    }

    /*
    Set the default cursor for buttons.
    */

    button,
    [role="button"] {
        cursor: pointer;
    }

    /*
    Make sure disabled buttons don't get the pointer cursor.
    */

    :disabled {
        cursor: default;
    }

    /*
    1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)
    2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
       This can trigger a poorly considered lint error in some tools but is included by design.
    */

    img,
    svg,
    video,
    canvas,
    audio,
    iframe,
    embed,
    object {
        display: block;
        /* 1 */
        vertical-align: middle;
        /* 2 */
    }

    /*
    Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
    */

    img,
    video {
        max-width: 100%;
        height: auto;
    }

    /* Make elements with the HTML hidden attribute stay hidden by default */

    [hidden] {
        display: none;
    }

    *, ::before, ::after {
        --tw-border-spacing-x: 0;
        --tw-border-spacing-y: 0;
        --tw-translate-x: 0;
        --tw-translate-y: 0;
        --tw-rotate: 0;
        --tw-skew-x: 0;
        --tw-skew-y: 0;
        --tw-scale-x: 1;
        --tw-scale-y: 1;
        --tw-pan-x: ;
        --tw-pan-y: ;
        --tw-pinch-zoom: ;
        --tw-scroll-snap-strictness: proximity;
        --tw-gradient-from-position: ;
        --tw-gradient-via-position: ;
        --tw-gradient-to-position: ;
        --tw-ordinal: ;
        --tw-slashed-zero: ;
        --tw-numeric-figure: ;
        --tw-numeric-spacing: ;
        --tw-numeric-fraction: ;
        --tw-ring-inset: ;
        --tw-ring-offset-width: 0px;
        --tw-ring-offset-color: #fff;
        --tw-ring-color: rgb(59 130 246 / 0.5);
        --tw-ring-offset-shadow: 0 0 #0000;
        --tw-ring-shadow: 0 0 #0000;
        --tw-shadow: 0 0 #0000;
        --tw-shadow-colored: 0 0 #0000;
        --tw-blur: ;
        --tw-brightness: ;
        --tw-contrast: ;
        --tw-grayscale: ;
        --tw-hue-rotate: ;
        --tw-invert: ;
        --tw-saturate: ;
        --tw-sepia: ;
        --tw-drop-shadow: ;
        --tw-backdrop-blur: ;
        --tw-backdrop-brightness: ;
        --tw-backdrop-contrast: ;
        --tw-backdrop-grayscale: ;
        --tw-backdrop-hue-rotate: ;
        --tw-backdrop-invert: ;
        --tw-backdrop-opacity: ;
        --tw-backdrop-saturate: ;
        --tw-backdrop-sepia: ;
        --tw-contain-size: ;
        --tw-contain-layout: ;
        --tw-contain-paint: ;
        --tw-contain-style: ;
    }

    ::backdrop {
        --tw-border-spacing-x: 0;
        --tw-border-spacing-y: 0;
        --tw-translate-x: 0;
        --tw-translate-y: 0;
        --tw-rotate: 0;
        --tw-skew-x: 0;
        --tw-skew-y: 0;
        --tw-scale-x: 1;
        --tw-scale-y: 1;
        --tw-pan-x: ;
        --tw-pan-y: ;
        --tw-pinch-zoom: ;
        --tw-scroll-snap-strictness: proximity;
        --tw-gradient-from-position: ;
        --tw-gradient-via-position: ;
        --tw-gradient-to-position: ;
        --tw-ordinal: ;
        --tw-slashed-zero: ;
        --tw-numeric-figure: ;
        --tw-numeric-spacing: ;
        --tw-numeric-fraction: ;
        --tw-ring-inset: ;
        --tw-ring-offset-width: 0px;
        --tw-ring-offset-color: #fff;
        --tw-ring-color: rgb(59 130 246 / 0.5);
        --tw-ring-offset-shadow: 0 0 #0000;
        --tw-ring-shadow: 0 0 #0000;
        --tw-shadow: 0 0 #0000;
        --tw-shadow-colored: 0 0 #0000;
        --tw-blur: ;
        --tw-brightness: ;
        --tw-contrast: ;
        --tw-grayscale: ;
        --tw-hue-rotate: ;
        --tw-invert: ;
        --tw-saturate: ;
        --tw-sepia: ;
        --tw-drop-shadow: ;
        --tw-backdrop-blur: ;
        --tw-backdrop-brightness: ;
        --tw-backdrop-contrast: ;
        --tw-backdrop-grayscale: ;
        --tw-backdrop-hue-rotate: ;
        --tw-backdrop-invert: ;
        --tw-backdrop-opacity: ;
        --tw-backdrop-saturate: ;
        --tw-backdrop-sepia: ;
        --tw-contain-size: ;
        --tw-contain-layout: ;
        --tw-contain-paint: ;
        --tw-contain-style: ;
    }

    .visible {
        visibility: visible;
    }

    .collapse {
        visibility: collapse;
    }

    .fixed {
        position: fixed;
    }

    .absolute {
        position: absolute;
    }

    .relative {
        position: relative;
    }

    .sticky {
        position: sticky;
    }

    .inset-0 {
        inset: 0px;
    }

    .inset-x-0 {
        left: 0px;
        right: 0px;
    }

    .left-0 {
        left: 0px;
    }

    .right-0 {
        right: 0px;
    }

    .top-0 {
        top: 0px;
    }

    .top-20 {
        top: 5rem;
    }

    .z-\[150\] {
        z-index: 150;
    }

    .m-0 {
        margin: 0px;
    }

    .m-1 {
        margin: 0.25rem;
    }

    .mx-auto {
        margin-left: auto;
        margin-right: auto;
    }

    .block {
        display: block;
    }

    .flex {
        display: flex;
    }

    .table {
        display: table;
    }

    .contents {
        display: contents;
    }

    .hidden {
        display: none;
    }

    .h-\[2px\] {
        height: 2px;
    }

    .h-\[calc\(100vh-105px\)\] {
        height: calc(100vh - 105px);
    }

    .max-h-full {
        max-height: 100%;
    }

    .w-1 {
        width: 0.25rem;
    }

    .w-1\/12 {
        width: 8.333333%;
    }

    .w-1\/2 {
        width: 50%;
    }

    .w-11 {
        width: 2.75rem;
    }

    .w-11\/12 {
        width: 91.666667%;
    }

    .w-3\/4 {
        width: 75%;
    }

    .w-full {
        width: 100%;
    }

    .min-w-40 {
        min-width: 10rem;
    }

    .min-w-80 {
        min-width: 20rem;
    }

    .max-w-2xl {
        max-width: 42rem;
    }

    .flex-grow {
        flex-grow: 1;
    }

    .table-auto {
        table-layout: auto;
    }

    .border-collapse {
        border-collapse: collapse;
    }

    .transform {
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .resize {
        resize: both;
    }

    .flex-col {
        flex-direction: column;
    }

    .flex-wrap {
        flex-wrap: wrap;
    }

    .items-start {
        align-items: flex-start;
    }

    .items-center {
        align-items: center;
    }

    .justify-start {
        justify-content: flex-start;
    }

    .justify-center {
        justify-content: center;
    }

    .justify-between {
        justify-content: space-between;
    }

    .justify-evenly {
        justify-content: space-evenly;
    }

    .gap-0 {
        gap: 0px;
    }

    .gap-1 {
        gap: 0.25rem;
    }

    .gap-2 {
        gap: 0.5rem;
    }

    .overflow-y-auto {
        overflow-y: auto;
    }

    .overflow-x-hidden {
        overflow-x: hidden;
    }

    .overflow-y-hidden {
        overflow-y: hidden;
    }

    .whitespace-nowrap {
        white-space: nowrap;
    }

    .rounded-md {
        border-radius: 0.375rem;
    }

    .rounded-sm {
        border-radius: 0.125rem;
    }

    .rounded-bl {
        border-bottom-left-radius: 0.25rem;
    }

    .rounded-br {
        border-bottom-right-radius: 0.25rem;
    }

    .rounded-tl {
        border-top-left-radius: 0.25rem;
    }

    .rounded-tr {
        border-top-right-radius: 0.25rem;
    }

    .border {
        border-width: 1px;
    }

    .border-2 {
        border-width: 2px;
    }

    .border-gray-200 {
        --tw-border-opacity: 1;
        border-color: rgb(229 231 235 / var(--tw-border-opacity));
    }

    .border-gray-300 {
        --tw-border-opacity: 1;
        border-color: rgb(209 213 219 / var(--tw-border-opacity));
    }

    .border-slate-700 {
        --tw-border-opacity: 1;
        border-color: rgb(51 65 85 / var(--tw-border-opacity));
    }

    .bg-gray-400 {
        --tw-bg-opacity: 1;
        background-color: rgb(156 163 175 / var(--tw-bg-opacity));
    }

    .bg-red-100 {
        --tw-bg-opacity: 1;
        background-color: rgb(254 226 226 / var(--tw-bg-opacity));
    }

    .bg-slate-700 {
        --tw-bg-opacity: 1;
        background-color: rgb(51 65 85 / var(--tw-bg-opacity));
    }

    .bg-white {
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity));
    }

    .p-2 {
        padding: 0.5rem;
    }

    .p-3 {
        padding: 0.75rem;
    }

    .p-4 {
        padding: 1rem;
    }

    .px-2 {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .px-4 {
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .px-8 {
        padding-left: 2rem;
        padding-right: 2rem;
    }

    .py-1 {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .py-4 {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }

    .pl-6 {
        padding-left: 1.5rem;
    }

    .pr-1 {
        padding-right: 0.25rem;
    }

    .text-lg {
        font-size: 1.125rem;
        line-height: 1.75rem;
    }

    .text-sm {
        font-size: 0.875rem;
        line-height: 1.25rem;
    }

    .text-xl {
        font-size: 1.25rem;
        line-height: 1.75rem;
    }

    .font-semibold {
        font-weight: 600;
    }

    .italic {
        font-style: italic;
    }

    .text-white {
        --tw-text-opacity: 1;
        color: rgb(255 255 255 / var(--tw-text-opacity));
    }

    .underline {
        text-decoration-line: underline;
    }

    .opacity-80 {
        opacity: 0.8;
    }

    .shadow {
        --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
        --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }

    .shadow-xl {
        --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
        --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }

    .outline {
        outline-style: solid;
    }

    .ring-gray-500 {
        --tw-ring-opacity: 1;
        --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity));
    }

    .brightness-50 {
        --tw-brightness: brightness(.5);
        filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
    }

    .filter {
        filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
    }

    .backdrop-brightness-90 {
        --tw-backdrop-brightness: brightness(.9);
        -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
        backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
    }

    .backdrop-filter {
        -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
        backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
    }

    .transition {
        transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
        transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
        transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 150ms;
    }

    .hover\:bg-slate-50:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(248 250 252 / var(--tw-bg-opacity));
    }

    .hover\:opacity-100:hover {
        opacity: 1;
    }

    .hover\:shadow-inner:hover {
        --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
        --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }

    .focus\:bg-slate-100:focus {
        --tw-bg-opacity: 1;
        background-color: rgb(241 245 249 / var(--tw-bg-opacity));
    }

    .active\:scale-95:active {
        --tw-scale-x: .95;
        --tw-scale-y: .95;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    }

    .active\:bg-slate-100:active {
        --tw-bg-opacity: 1;
        background-color: rgb(241 245 249 / var(--tw-bg-opacity));
    }

    .active\:opacity-100:active {
        opacity: 1;
    }

    .active\:ring-2:active {
        --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
        box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
    }

    @media (min-width: 640px) {
        .sm\:w-4\/5 {
            width: 80%;
        }

        .sm\:w-full {
            width: 100%;
        }
    }

    @media (min-width: 768px) {
        .md\:w-3\/5 {
            width: 60%;
        }
    }

    @tailwind base;
    @tailwind components;
    @tailwind utilities;

    body {
        font-family: 'Roboto', sans-serif;
    }

    .navigation {
        height: 100vh;
        position: sticky;
        top: 0;
    }

    .navigation .mask {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .content {
        height: 60px;
        vertical-align: top;
        text-align: center;
    }

    .navigation .mask img {
        width: 50px;
        max-width: 100%;
    }

    .desc:hover {
        text-decoration: underline;
        cursor: pointer;
    }

    .event-box {
        transition: height 0.3s ease-in-out;
        overflow: hidden;
        overflow-y: clip;
    }

    .event {
        position: absolute;
        width: 100%;
        background-color: rgba(255, 0, 0, 0.1);
        border: 1px solid #f00;
        box-sizing: border-box;
    }

    .legend {
        margin: 20px 0;
    }

    .print-hall {
        display: none;
    }

    #modal .title {
        font-size: 20px;
    }

    #modal .subtitle {
        font-size: 18px;
    }

    .program.table {
        /*margin-bottom: 0;*/
        table-layout: fixed;
    }

    .program tr td {
        text-align: center;
        vertical-align: bottom;
        font-size: 12px;
        /*width: calc(100% / 5);*/
    }

    .program tr td.hour,
    .program tr th.date {
        white-space: nowrap;
        width: 120px;
        vertical-align: middle;
    }

    .program .head .date {
        font-weight: bold;

    }

    .program .head .date .weekday {
        font-size: 16px;
        margin-bottom: 0;
    }

    .program .head .date .day {
        font-size: 20px;
        margin-bottom: 0;
    }

    .program .head .date .month {
        margin-bottom: 0;
    }

    .program .head th {
        text-align: center;
        vertical-align: middle;
    }

    .program .head th img {
        float: right;
        width: 20px;
        cursor: pointer;
    }

    .session {
        margin: 0;
        text-align: center;
    }

    .days-buttons {
        background: #593a0f;
        color: white;
        font-size: 1.5rem;
    }

    @media only screen and (max-width: 600px) {
        .days-buttons {
            font-size: 1.2rem;
        }
    }

    .days-buttons button {
        opacity: 0.5;
    }

    .days-buttons button.selected {
        opacity: 1;
    }

    .time-step {
        width: 2rem;
        max-width: 60px;
        font-weight: bold;
        height: 30px;
        vertical-align: top;
    }

    .search-item {
        padding-top: 15px;
        padding-bottom: 15px;
    }

    .table-header {
        border: none;
        position: sticky;
        z-index: 100;
        top: 3rem;
        background-color: rgb(202, 181, 94);
        /*width: 25vw;*/
    }

    .table-container {
        overflow-x: auto;
    }

    .program-table {
        background: #f6f6f6;
    }

    #program_sz .items {
        padding: 0 0 15px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: white;
    }

    #program_sz .item:not(:first-child) {
        padding-top: 15px;
    }

    #program_sz .item {
        width: 100%;
        text-align: center;
    }

    #program_sz .hall {
        display: flex;
        align-items: center;
    }

    #program_sz .current-hall {
        margin: 0 !important;
        padding: 10px 0;

    }

    #program_sz .hall .arrow {
        font-size: 25px;
    }

    #program_sz p {
        margin-bottom: 15px;
    }

    #program_sz .title {
        margin-bottom: 0 !important;
    }

    #program_sz .subtitle {
        margin-top: 5px !important;
        margin-bottom: 15px !important;
    }

    .flex {
        display: flex;
    }


    .program .head th,
    .btn-custom,
    .panel-custom > .panel-heading {
        color: white;
    }

    .m-0 {
        margin-bottom: 0 !important;
    }

    .m-1 {
        margin-bottom: 15px !important;
    }

    .btn-group-custom {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 0 15px;
    }

    .panel-subtitle {
        font-size: 14px;
        margin-top: 5px;
        margin-bottom: 0;
    }

    .red {
        color: red;
        font-weight: bold;
    }

    .red-border {
        border: 0 solid red;
        border-width: 0 3px 3px;
    }

    /* brightness-50 backdrop-brightness-90 */
    .darkenBackground {
        filter: brightness(.5);
        backdrop-filter: brightness(1);
        -webkit-backdrop-filter: brightness(1);
        box-shadow: 0px 0px 1px 5000px rgba(0, 0, 0, 0.5);
    }

    .backdrop {
        background-color: rgba(0, 0, 0, 0.5);
    }

    .placeholder {
        width: 25%;
        /* height: 104px; */
    }

    .background_color {
        position: fixed;
        inset: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgb(246, 246, 246);
        /* bigger than app, lesser than popup */
        z-index: 8000;
    }

    @media print {
        @page {
            size: auto;  /* auto is the initial value */
            margin: 0; /* this affects the margin in the printer settings */
        }

        html {
            margin: 0;
        }

        body {
            padding: 10mm 15mm 10mm 15mm;
        }

        .search-item {
            display: none;
        }

        .print-hall .program {
            /*page-break-before: always;*/
        }

        .print-hall .program .date .weekday,
        .print-hall .program .date .day,
        .print-hall .program .date .month {
            font-size: 14px;
            line-height: 1;
        }

        .header:not(:nth-of-type(1)) {
            page-break-before: always;
        }

        .program {
            margin-bottom: 0;
        }

        .page-program {
            display: none;
        }

        .print-hall {
            display: block;

        }
    }

    @media only screen and (max-width: 600px) {
        .date-button {
            font-size: 14px;
        }
    }
</style>
